// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BookingRail-module__rail___mbHLy {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex-shrink: 0;
  padding: 16px 12px;
  background: #ffffff;
  border: 1px solid #e4e4e7;
  border-radius: 8px;
  height: 100%;
}

.BookingRail-module__start___t8HJz {
  display: flex;
  align-items: last baseline;
  gap: 4px;
  font-family: "Barlow Condensed", "IBM Plex Sans Condensed", "Arial Narrow", sans-serif;
  font-size: 39px;
  font-weight: 800;
  letter-spacing: -0.01em;
  font-variant-numeric: tabular-nums;
  color: #18181b;
}

.BookingRail-module__stack___UBF_O {
  display: flex;
  flex-direction: column;
  line-height: 19.5px;
}

.BookingRail-module__meridiem___gHkzr {
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0.04em;
}

.BookingRail-module__zone___E_wzF {
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.04em;
  color: #71717a;
}

.BookingRail-module__block___tGwUs {
  display: flex;
  align-items: flex-start;
  width: 100%;
  margin-top: 4px;
  padding: 4px 8px;
  border-left: 4px solid;
  border-radius: 6px;
  font-family: "IBM Plex Mono", monospace;
  font-size: 12px;
  font-weight: 500;
}

.BookingRail-module__end___PyATi {
  margin-top: 6px;
  font-family: "Barlow Condensed", "IBM Plex Sans Condensed", "Arial Narrow", sans-serif;
  font-size: 17px;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  color: #71717a;
}

.BookingRail-module__compact___WwlGW {
  width: 96px;
  padding: 12px 8px;
}
.BookingRail-module__compact___WwlGW .BookingRail-module__start___t8HJz {
  font-size: 24px;
}
.BookingRail-module__compact___WwlGW .BookingRail-module__stack___UBF_O {
  line-height: 12px;
}
.BookingRail-module__compact___WwlGW .BookingRail-module__meridiem___gHkzr {
  font-size: 12px;
}
.BookingRail-module__compact___WwlGW .BookingRail-module__zone___E_wzF {
  font-size: 10px;
}
.BookingRail-module__compact___WwlGW .BookingRail-module__end___PyATi {
  font-size: 15px;
}`, "",{"version":3,"sources":["webpack://./src/pages/CareOrchestration/components/BookingRail/BookingRail.module.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;AADF;;AAIA;EACE,aAAA;EACA,0BAAA;EACA,QAAA;EACA,sFAlBQ;EAmBR,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,kCAAA;EACA,cAAA;AADF;;AAIA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;AADF;;AAIA;EACE,eAAA;EACA,gBAAA;EACA,sBAAA;AADF;;AAIA;EACE,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,cAAA;AADF;;AAIA;EACE,aAAA;EACA,uBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,kBAAA;EACA,uCAAA;EACA,eAAA;EACA,gBAAA;AADF;;AAIA;EACE,eAAA;EACA,sFA5DQ;EA6DR,eAAA;EACA,gBAAA;EACA,kCAAA;EACA,cAAA;AADF;;AAIA;EACE,WAAA;EACA,iBAAA;AADF;AAGE;EACE,eAAA;AADJ;AAIE;EACE,iBAAA;AAFJ;AAKE;EACE,eAAA;AAHJ;AAME;EACE,eAAA;AAJJ;AAOE;EACE,eAAA;AALJ","sourcesContent":["$display: 'Barlow Condensed', 'IBM Plex Sans Condensed', 'Arial Narrow', sans-serif;\n\n.rail {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  flex-shrink: 0;\n  padding: 16px 12px;\n  background: #ffffff;\n  border: 1px solid #e4e4e7;\n  border-radius: 8px;\n  height: 100%;\n}\n\n.start {\n  display: flex;\n  align-items: last baseline;\n  gap: 4px;\n  font-family: $display;\n  font-size: 39px;\n  font-weight: 800;\n  letter-spacing: -0.01em;\n  font-variant-numeric: tabular-nums;\n  color: #18181b;\n}\n\n.stack {\n  display: flex;\n  flex-direction: column;\n  line-height: 19.5px;\n}\n\n.meridiem {\n  font-size: 16px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n}\n\n.zone {\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  color: #71717a;\n}\n\n.block {\n  display: flex;\n  align-items: flex-start;\n  width: 100%;\n  margin-top: 4px;\n  padding: 4px 8px;\n  border-left: 4px solid;\n  border-radius: 6px;\n  font-family: 'IBM Plex Mono', monospace;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.end {\n  margin-top: 6px;\n  font-family: $display;\n  font-size: 17px;\n  font-weight: 700;\n  font-variant-numeric: tabular-nums;\n  color: #71717a;\n}\n\n.compact {\n  width: 96px;\n  padding: 12px 8px;\n\n  .start {\n    font-size: 24px;\n  }\n\n  .stack {\n    line-height: 12px;\n  }\n\n  .meridiem {\n    font-size: 12px;\n  }\n\n  .zone {\n    font-size: 10px;\n  }\n\n  .end {\n    font-size: 15px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"rail": `BookingRail-module__rail___mbHLy`,
	"start": `BookingRail-module__start___t8HJz`,
	"stack": `BookingRail-module__stack___UBF_O`,
	"meridiem": `BookingRail-module__meridiem___gHkzr`,
	"zone": `BookingRail-module__zone___E_wzF`,
	"block": `BookingRail-module__block___tGwUs`,
	"end": `BookingRail-module__end___PyATi`,
	"compact": `BookingRail-module__compact___WwlGW`
};
module.exports = ___CSS_LOADER_EXPORT___;
